import { BaseAPIRequestFactory, RequiredError } from './baseapi';
import type { Configuration } from '../configuration';
import { RequestContext, HttpMethod, ResponseContext, HttpInfo } from '../http/http';
import { ObjectSerializer } from '../models/ObjectSerializer';
import { ApiException } from './exception';
import { isCodeInRange } from '../util';
import type {SecurityAuthentication} from '../auth/auth';
import type {HttpFile} from '../http/http';


import { UpdateCloudResourceConfigurationRequest } from '../models/UpdateCloudResourceConfigurationRequest';

/**
 * no description
 */
export class UpdateResourceConfigurationApiRequestFactory extends BaseAPIRequestFactory {

  /**
   * Update configuration for an inventory resource
   * @param id ID of the inventory resource
   * @param projectId The project ID
   * @param updateCloudResourceConfigurationRequest Fields to update for the inventory resource configuration
   */
  public async updateResourceConfiguration(id: string, projectId: string, updateCloudResourceConfigurationRequest: UpdateCloudResourceConfigurationRequest, _options?: Configuration): Promise<RequestContext> {
    let _config;
    if (!_options) {
      _config = this.configuration;
    } else {
      _config = Object.assign({}, _options, this.configuration);
    }
    


    // verify required parameter 'id' is not null or undefined
    if (id === null || id === undefined) {
      throw new RequiredError("UpdateResourceConfigurationApi", "updateResourceConfiguration", "id");
    }


    // verify required parameter 'projectId' is not null or undefined
    if (projectId === null || projectId === undefined) {
      throw new RequiredError("UpdateResourceConfigurationApi", "updateResourceConfiguration", "projectId");
    }


    // verify required parameter 'updateCloudResourceConfigurationRequest' is not null or undefined
    if (updateCloudResourceConfigurationRequest === null || updateCloudResourceConfigurationRequest === undefined) {
      throw new RequiredError("UpdateResourceConfigurationApi", "updateResourceConfiguration", "updateCloudResourceConfigurationRequest");
    }


    // Path Params
    const localVarPath = '/projects/{projectId}/inventory/{id}/configuration'
      .replace('{' + 'id' + '}', encodeURIComponent(String(id)))
      .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)));

    let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
    // Make Request Context
    const requestContext = _config.baseServer!.makeRequestContext(localVarPath, HttpMethod.PATCH, signal);
    requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8")


    // Body Params
    const contentType = "application/json"
    requestContext.setHeaderParam("Content-Type", contentType);
    const serializedBody = JSON.stringify(ObjectSerializer.serialize(updateCloudResourceConfigurationRequest, "UpdateCloudResourceConfigurationRequest", ""));
    requestContext.setBody(serializedBody);

    let authMethod: SecurityAuthentication | undefined;
    // Apply auth methods
    authMethod = _config.authMethods!["ApiKeyAuth"]
    if (authMethod?.applySecurityAuthentication) {
      await authMethod?.applySecurityAuthentication(requestContext);
    }

    return requestContext;
  }

}

export class UpdateResourceConfigurationApiResponseProcessor {

  /**
   * Unwraps the actual response sent by the server from the response context and deserializes the response content
   * to the expected objects
   *
   * @params response Response returned by the server for a request to updateResourceConfiguration
   * @throws ApiException if the response code was not in [200, 299]
   */
   public async updateResourceConfigurationWithHttpInfo(response: ResponseContext): Promise<HttpInfo<void >> {
    if (isCodeInRange("204", response.httpStatusCode)) {
      return new HttpInfo(response.httpStatusCode, response.headers, response.body, undefined);
    }
    if (isCodeInRange("400", response.httpStatusCode)) {
      throw new ApiException<undefined>(response.httpStatusCode, "Invalid request body or parameters", undefined, response.headers, response);
    }
    if (isCodeInRange("403", response.httpStatusCode)) {
      throw new ApiException<undefined>(response.httpStatusCode, "Insufficient permissions to update the requested resource configuration", undefined, response.headers, response);
    }
    if (isCodeInRange("404", response.httpStatusCode)) {
      throw new ApiException<undefined>(response.httpStatusCode, "Resource configuration not found", undefined, response.headers, response);
    }
    if (isCodeInRange("500", response.httpStatusCode)) {
      throw new ApiException<undefined>(response.httpStatusCode, "Internal server error", undefined, response.headers, response);
    }
    if (isCodeInRange("1XX", response.httpStatusCode)) {
      throw new ApiException<undefined>(response.httpStatusCode, "Informational", undefined, response.headers, response);
    }
    if (isCodeInRange("3XX", response.httpStatusCode)) {
      throw new ApiException<undefined>(response.httpStatusCode, "Redirect", undefined, response.headers, response);
    }
    if (isCodeInRange("4XX", response.httpStatusCode)) {
      const body: Error = ObjectSerializer.deserialize(
        await response.body.json(),
        "Error", ""
      ) as Error;
      throw new ApiException<Error>(response.httpStatusCode, "Client Error", body, response.headers, response);
    }
    if (isCodeInRange("5XX", response.httpStatusCode)) {
      const body: Error = ObjectSerializer.deserialize(
        await response.body.json(),
        "Error", ""
      ) as Error;
      throw new ApiException<Error>(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
    }

    // Work around for missing responses in specification, e.g. for petstore.yaml
    if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
      throw new ApiException<string | Blob | undefined>(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
    }
    const body: void = await response.body.json() as void;
    return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
  }

}
